import React from "react";
import { Popup, Icon } from "semantic-ui-react";

interface IToolTipProps {
  children?: any;
  cssClasses: string;
  outerCssClasses?: string;
}

const ToolTip: React.FC<IToolTipProps> = (props: IToolTipProps) => {
  return (
    <Popup
      trigger={<Icon name="help" size="small" circular className="tooltip" />}
      on="click"
      position="top right"
      basic
      className={props.cssClasses}
    >
      <Popup.Content>{props.children}</Popup.Content>
    </Popup>
  );
};

export const ProductToolTip: React.FC<IToolTipProps> = (props: IToolTipProps) => {
  return (
      <Popup
          trigger={<a style={{cursor:"pointer",display:"inline-block",textAlign: "right", paddingLeft: "25%"}}>Click for Product Information</a>}
          on="click"
          position="top right"
          basic
          style={{textAlign: "center"}}
          className={props.cssClasses}
      >
        <Popup.Content>{props.children}</Popup.Content>
      </Popup>
  );
};

export default ToolTip;

